import React from "react";
import { useOffline } from "../../../offline/OfflineProvider";
import OfflineStatusBadge from "../../../offline/OfflineStatusBadge";
import { useNavigationGuard } from "../../../hooks/useNavigationGuard";
import SearchBar from "../../common/SearchBar/SearchBar";
import "./Header.css";
import { getAPIBaseURL } from "../../../utils/api";
import { loadLastEnv } from "../../../offline/envStore";
import { lockOffline } from "../../../offline/offlineLock";
import { clearSWKeys } from "../../../offline/swRegistration";
import { setKeys } from "../../../offline/secure.js";
import logoutIcon from "images/logout.svg";
import settingsIcon from "images/settings.svg";

const API_BASE_URL = getAPIBaseURL();

const handleLogout = async () => {
  // Lock the offline copy on the user's INTENT to leave, before the request:
  // the boot probe serves the cached snapshot whenever the backend is
  // unreachable, with no authentication possible, so an unlocked store would
  // stay readable to whoever opens the app offline next. The data survives —
  // the next successful online sign-in unlocks it (see offline/offlineLock).
  try { lockOffline(loadLastEnv()?.TENANT); } catch { /* never block logout */ }
  try { setKeys(null); clearSWKeys(); } catch { /* never block logout */ }  // encrypted copy: forget the key now
  try {
    console.log("Attempting to logout...");
    const response = await fetch(`${API_BASE_URL}/api/logout`, {
      method: "POST",
      credentials: "include",
    });

    console.log("Logout response status:", response.status);

    if (response.ok) {
      const data = await response.json();
      console.log("Logout successful, redirecting...");
      window.location.href = data.redirectUrl;
    } else {
      const errorText = await response.text();
      console.error("Logout failed:", response.status, errorText);
    }
  } catch (error) {
    console.error("Error during logout:", error.message);
  }
};

const Header = React.forwardRef((props, ref) => {
  const customNavigate = useNavigationGuard();
  // Tenant label comes from the boot-time /api/env snapshot (works offline too).
  const { env } = useOffline();
  const tenantName = env?.TENANT_DISPLAY_NAME || env?.TENANT || '';

  const handleSettingsClick = () => {
    console.log("Settings clicked, navigating to '/settings'");
    customNavigate("/route/settings");
  };

  return (
    <header ref={ref} className="header">
      <SearchBar />
      <div className="header-actions">
        <OfflineStatusBadge />
        {tenantName && <span className="tenant-indicator">{tenantName}</span>}
        <button
          className="action-button"
          onClick={handleSettingsClick}
          aria-label="Einstellungen öffnen"
          data-tooltip="Einstellungen"
          type="button"
        >
          <img src={settingsIcon} alt="Settings" className="action-icon" />
        </button>
        <button
          className="action-button"
          onClick={handleLogout}
          aria-label="Abmelden"
          data-tooltip="Abmelden"
          type="button"
        >
          <img src={logoutIcon} alt="Logout" className="action-icon" />
        </button>
      </div>
    </header>
  );
});

export default Header;
